import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './assets/less/home.less';
import ECharts from 'vue-echarts';
import Http from './api/http';

Vue.config.productionTip = false;
Vue.component('v-chart', ECharts);

Vue.prototype.$http = new Http({
  productionApi: 'https://yw.zberp.net/erp-yw/',
  developmentApi: 'http://testyw.zberp.net/erp-yw/',
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
